import React from "react";

export default function ResultBanner({ result, target, shareResult }) {
  if (!result) return null;

  const isWin = result === "won";

  return (
    <section className={`result-banner ${isWin ? "result-win" : "result-lose"}`}>
      <div>
        <div className="result-title">{isWin ? "Du satte den!" : "Rundan är över."}</div>
        <div className="result-text">Dagens korv är {target.name}.</div>
        <p>{target.note}</p>
      </div>

      <button type="button" className="secondary-button" onClick={shareResult}>
        Dela resultat
      </button>
    </section>
  );
}
